import { gql } from '@apollo/client';
import { client } from 'graphql/client';

export const SEND_SMS = gql`
  mutation SendSms($input: SendSmsInput!) {
    result: sendSms(input: $input) {
      success
      messageId
    }
  }
`;

interface SendSmsResponse {
  result: {
    success: boolean;
    messageId?: string;
  };
}

export interface SendSmsInput {
  message: string;
  stopNumber: number;
  fullName: string;
  subStopNumber:string;
  driverId:number;
  driverName: string;
  trackingNumber:string;
  orderAddressId: number;
}

interface SendSmsInputVariables {
  input: SendSmsInput;
}

// 发送短信接口（支持 Twilio 和降级到系统短信）
export const sendSms = async (input: SendSmsInput): Promise<{ success: boolean; messageId?: string; shouldFallback?: boolean }> => {
  try {
    // 调用后端 Twilio API
    const { data } = await client.mutate<SendSmsResponse, SendSmsInputVariables>({
      mutation: SEND_SMS,
      variables: { input },
    });
    
    const result = data?.result || { success: false };
    
    // 如果发送失败，标记需要降级
    if (!result.success) {
      return {
        ...result,
        shouldFallback: true // 标记需要降级到系统短信
      };
    }
    
    return result;
  } catch (error: any) {
    console.error('Twilio SMS send failed:', error);
    
    // 判断是否为网络错误或可重试的错误
    const isNetworkError = error.networkError || 
                          error.message?.includes('network') ||
                          error.message?.includes('timeout') ||
                          error.message?.includes('Network request failed');
    
    // 如果是网络错误，返回降级标记
    if (isNetworkError) {
      return {
        success: false,
        shouldFallback: true // 标记需要降级到系统短信
      };
    }
    
    // 其他错误（如权限错误、参数错误等），不降级
    return {
      success: false,
      shouldFallback: false
    };
  }
};

